import type { ReactNode } from 'react';
type Tone = 'primary' | 'accent' | 'ok' | 'warn' | 'danger';
const TONE: Record<Tone, string> = {
  primary: 'bg-primary-light text-primary',
  accent: 'bg-accent-light text-accent-dark',
  ok: 'bg-ok-light text-ok',
  warn: 'bg-warn-light text-warn',
  danger: 'bg-danger-light text-danger',
};
export function KpiCard({
  label,
  value,
  unit,
  delta,
  sub,
  icon,
  tone = 'primary',
}: {
  label: string;
  value: ReactNode;
  unit?: string;
  delta?: number;
  sub?: string;
  icon?: ReactNode;
  tone?: Tone;
}) {
  const positive = delta != null && delta >= 0;
  return (
    <div className="bo-card p-5 flex flex-col gap-2 min-h-[120px]">
      <div className="flex justify-between items-start">
        <div className="text-sm-label font-semibold text-ink-3">{label}</div>
        {icon && (
          <div
            className={`w-8 h-8 rounded-card flex items-center justify-center ${TONE[tone]}`}
          >
            {icon}
          </div>
        )}
      </div>
      <div className="flex items-baseline gap-1.5 mt-auto">
        <div className="num text-[30px] font-semibold text-ink leading-tight -tracking-[0.6px]">
          {value}
        </div>
        {unit && <div className="text-body text-ink-3 font-medium">{unit}</div>}
      </div>
      <div className="flex items-center gap-2 text-sm-label">
        {delta != null && (
          <span
            className={`num inline-flex items-center gap-0.5 font-bold ${positive ? 'text-ok' : 'text-danger'}`}
          >
            {positive ? '▲' : '▼'} {Math.abs(delta * 100).toFixed(1)}%
          </span>
        )}
        {sub && <span className="text-ink-3">{sub}</span>}
      </div>
    </div>
  );
}
